export class SavedAudit {
    public SaveID:number = -1;
    public AuditName: string = "";
    public AuditGUID: string = "";
    public LocationName: string = "";
    public DateStarted: Date;
    public LastEdited: Date;
    public FormattedDateStarted: string = "";
    public FormattedLastEdited: string = "";
    //Front end only
    public HasLocalVersion:boolean = false;
    public DeleteReady:boolean = false;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}